import { render, staticRenderFns } from "./InstallationChangelogList.vue?vue&type=template&id=50e8adb0&scoped=true&"
import script from "./InstallationChangelogList.vue?vue&type=script&lang=js&"
export * from "./InstallationChangelogList.vue?vue&type=script&lang=js&"
import style0 from "./InstallationChangelogList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./InstallationChangelogList.vue?vue&type=style&index=1&id=50e8adb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e8adb0",
  null
  
)

export default component.exports